module.exports = __webpack_public_path__ + "img/bg_theme0001_burger.b384c451.jpg";